import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="haydi-footer">
      {t('footerCopyright', { year: new Date().getFullYear() })}
    </footer>
  );
}

export default Footer;
